module.exports = __webpack_public_path__ + "static/media/martynad.17f8b764.jpg";